export enum AttendanceRequestType {
  ADDITIONAL_PERMANENT_ACCESS = 'Additional Permanent Access',
  TEMPORARY_ACCESS = 'Temporary Access',
  NO_PUNCH = 'No Punch - Morning / Evening / Full Day',
  LATE_PUNCH = 'Late Punch',
  TECHNICAL_ISSUE = 'Technical Issue',
}
